import { AppState, FeedPageManchesterAppState } from '../../../initialStateRegistration';
import { FeedPageManchesterImageSection, FeedPageManchesterSection } from './feedPageManchester.initialState';

export const getFeedPage = (state: AppState) => (state as FeedPageManchesterAppState).template;

export const getSectionDataByKey = (key: FeedPageManchesterSection | FeedPageManchesterImageSection) => (state: AppState) => getFeedPage(state)[key];

export const getSectionArticlesByKey = (key: FeedPageManchesterSection | FeedPageManchesterImageSection) => (state: AppState) => getFeedPage(state)[key].articles;

export const getSectionImageByKey = (key: FeedPageManchesterImageSection) => (state: AppState) => getFeedPage(state)[key].image;

export const getSportradarProps = () => (state: AppState) => getFeedPage(state).sportradarProps;

export const getPagination = (state: AppState) => getFeedPage(state).pagination;

export const getMetadataDescription = (state: AppState) => getFeedPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getFeedPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getFeedPage(state).metadataImage;

export const getHreflangData = (state: AppState) => getFeedPage(state).hreflangData;

export const getOutbrainWidgetID = (state: AppState) => getFeedPage(state).outbrainWidgetID;

export const getShowRecommendationsAdvertisement = (state: AppState) => getFeedPage(state).showRecommendationsAdvertisement;
